import React, { useEffect, useState } from "react";
import "../styles/QnaManagementPage.css"; // ✅ 새로운 스타일 적용
import MyPageSidebar from "./MyPageSidebar";
import QnaCard from "./QnaCard"; // ✅ Q&A 카드 컴포넌트
import MyPageEmpty from "./MyPageEmpty"; // ✅ 데이터가 없을 경우

const QnaManagementPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [qnaList, setQnaList] = useState([]);  // ✅ 초기값을 빈 배열로 설정
    const [filter, setFilter] = useState("latest"); // 최신순(default)
    const [statusFilter, setStatusFilter] = useState("all"); // 전체(default)
    const [visibleQna, setVisibleQna] = useState(5); // ✅ 페이지네이션 (5개씩 표시)
    const [qnaCount, setQnaCount] = useState(0); // ✅ Q&A 데이터 개수

    // ✅ Q&A 데이터 반영
    const fetchQnaList = async () => {
        try {
            const response = await fetch("/api/mypage/qna"); // ✅ 실제 API 호출
            if (response.ok) {
                const data = await response.json();

                // ✅ API 응답 데이터 확인
                console.log("API 응답 데이터:", data);

                // ✅ 데이터가 객체 형태일 경우 배열로 변환
                const qnaData = Array.isArray(data.qnaManagementData) ? data.qnaManagementData : [];

                setQnaList(qnaData);
                setQnaCount(data.qnaManagementDataCounts || 0);
            } else {
                throw new Error("Q&A 데이터를 가져오는데 실패했습니다.");
            }
        } catch (error) {
            console.error("Q&A 데이터를 불러오는 중 오류 발생:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchQnaList();
    }, []);

    // ✅ 필터링 적용
    const filteredQnaList = qnaList.length > 0 ? qnaList
        .filter(item => item.title !== null)
        .filter(item =>
            statusFilter === "all"
                ? true
                : statusFilter === "답변대기"
                    ? item.answer === null
                    : item.answer !== null
        )
        .sort((a, b) =>
            filter === "latest"
                ? new Date(b.regDate.replace(/\./g, "-")) - new Date(a.regDate.replace(/\./g, "-"))
                : new Date(a.regDate.replace(/\./g, "-")) - new Date(b.regDate.replace(/\./g, "-"))
        ) : [];

    const loadMoreQna = () => {
        setVisibleQna(prev => prev + 5);
    };

    if (isLoading) return <p>로딩중...</p>;

    // ✅ Q&A 데이터 갱신
    const refreshQnaData = () => {
        setIsLoading(true);
        fetchQnaList();
    };

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="mypage-qna-content-list-container">
                <h2 className="mypage-title">Q&A 관리</h2>

                {/* ✅ 필터 드롭다운 */}
                <div className="qna-filter">
                    <select className="qna-filter-select" value={filter} onChange={(e) => setFilter(e.target.value)}>
                        <option value="latest">최신순</option>
                        <option value="oldest">오래된순</option>
                    </select>
                    <select className="qna-filter-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                        <option value="all">전체</option>
                        <option value="답변대기">답변대기</option>
                        <option value="답변완료">답변완료</option>
                    </select>
                </div>

                {/* ✅ Q&A 데이터가 없을 경우, MyPageEmpty 표시 */}
                {filteredQnaList.length === 0 ? (
                    <MyPageEmpty />
                ) : (
                    <>
                        {filteredQnaList.slice(0, visibleQna).map((item) => (
                            <QnaCard key={item.articleId} item={item} refreshQnaData={refreshQnaData} />
                        ))}

                        {/* ✅ 더보기 버튼 */}
                        {filteredQnaList.length > visibleQna && (
                            <button className="qna-load-more-btn" onClick={loadMoreQna}>더보기 +</button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default QnaManagementPage;
